module.exports = __webpack_public_path__ + "static/media/callgage-insta.2483e71f.svg";